module.exports = __webpack_public_path__ + "img/dingdingThird.18387d68.png";